import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import {
  getAllProductOnline,
  getLastDoc,
  resetLoadingNumber,
  SetBottomSizeFilter,
  SetSelectdPage,
  SetSignIn,
  SetSignUpp,
  SetSizeFilter,
  SetTopSizeFilter,
  SortProducts,
} from "./features/Products/ProductSlice";
import { SetSearch } from "./features/TopSearches/TopSearchesSlice";
import { FillMybags } from "./features/Bag/MybagSlice";
import { GetBalances } from "./features/Flags/FlagsSlice";
import libasmini from "../src/assets/images/libasmini.svg";
import menuclose from "../src/assets/images/mobile-menu-cross.svg";
import menudown from "../src/assets/images/mobile-menu-downarrow.svg";
import menuup from "../src/assets/images/menuup.svg";
import Search from "../src/assets/images/Search1.png";
import LibasMenuDesigners from "./LibasMenuDesigners";
import LibasMenuWomens from "./LibasMenuWomens";
import LibasMenuMens from "./LibasMenuMens";
import { UserContext } from "./context/user.context";
import LibasMenuVintage from "./LibasMenuVintage";
import LibasMenuBags from "./LibasMenuBags";
import LibasMenuShoes from "./LibasMenuShoes";
import LibasMenuWatchandjews from "./LibasMenuWatchandjews";
import LibasMenuChildren from "./LibasMenuChildren";
import LibasMenuSale from "./LibasMenuSale";
const LibasMenu = ({
  constant,
  ShopAll,
  setSignIn,
  signOutUser,
  arabStyle,
  i18n,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentUser, show, setShowSearchh } = useContext(UserContext);
  const [seacrhDrop, setSeacrhDrop] = useState(false);
  const [activeFilter, setActiveFilter] = useState(null);
  const [hide, setHide] = useState(false);
  const [searchQ, setSearchQ] = useState("");
  // State to track which category is expanded (if any)
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [expandedSubcategories, setExpandedSubcategories] = useState({});
  // Toggle main category expansion
  const toggleCategory = (category) => {
    if (expandedCategory === category) {
      setExpandedCategory(null);
    } else {
      setExpandedCategory(category);
    }
  };

  // Toggle subcategory expansion
  const toggleSubcategory = (subcategory) => {
    setExpandedSubcategories((prev) => ({
      ...prev,
      [subcategory]: !prev[subcategory],
    }));
  };

  // Helper function to close menu and navigate
  const navigateTo = (path) => {
    navigate(path);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  // Function to handle shop all
  const handleShopAll = () => {
    ShopAll();
    setShowSearchh(false);
    navigate("/products");
    dispatch(SetSizeFilter([]));
    dispatch(SetTopSizeFilter([]));
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
    dispatch(SetSearch(""));
    dispatch(resetLoadingNumber(30));
  };

  function handleSearch(event) {
    if (event.key === "Enter" || event.key === "Done") {
      setShowSearchh(false);
      dispatch(getAllProductOnline([]));
      dispatch(SetSearch(event.target.value));
      setSeacrhDrop(false);
      dispatch(SetSelectdPage(0));
      sessionStorage.setItem("selectedItemIndex", "");
      dispatch(resetLoadingNumber(30));
      dispatch(SortProducts(""));
      dispatch(SetSizeFilter([]));
      dispatch(SetTopSizeFilter([]));
      dispatch(SetBottomSizeFilter([]));
      navigate("/products");
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      setShowSearchh(false);
    } else {
      setSeacrhDrop(true);
    }
  }
  // Function to navigate to filtered products
  const navigateToCategory = (category, subcategory = null) => {
    // setShowSearchh(false);
    // Reset filters
    dispatch(SetSizeFilter([]));
    dispatch(SetTopSizeFilter([]));
    dispatch(SetSearch(""));

    dispatch({
      type: "SET_CATEGORY_FILTER",
      payload: { category, subcategory },
    });

    navigate("/products");
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };
  function selectedPageNull() {
    dispatch(SetSizeFilter([]));
    dispatch(SetTopSizeFilter([]));
    dispatch(SetBottomSizeFilter([]));
    dispatch(getAllProductOnline([]));
    dispatch(getLastDoc(null));
    dispatch(SetSelectdPage(0));
    dispatch(SetSearch(""));
    setShowSearchh(false);
  }
  // Animation variants for main category container
  const categoryContainerVariants = {
    hidden: { opacity: 0, height: 0 },
    visible: {
      opacity: 1,
      height: "auto",
      transition: {
        duration: 0.3,
        when: "beforeChildren",
        staggerChildren: 0.05,
      },
    },
    exit: {
      opacity: 0,
      height: 0,
      transition: {
        duration: 0.2,
        when: "afterChildren",
        staggerChildren: 0.05,
        staggerDirection: -1,
      },
    },
  };

  // Animation variants for subcategory items
  const subcategoryItemVariants = {
    hidden: { opacity: 0, x: -10 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.2 },
    },
    exit: {
      opacity: 0,
      x: -10,
      transition: { duration: 0.1 },
    },
  };

  // Animation variants for nested subcategory container
  const nestedMenuVariants = {
    hidden: { opacity: 0, height: 0 },
    visible: {
      opacity: 1,
      height: "auto",
      transition: {
        duration: 0.25,
        when: "beforeChildren",
        staggerChildren: 0.03,
      },
    },
    exit: {
      opacity: 0,
      height: 0,
      transition: {
        duration: 0.2,
        when: "afterChildren",
        staggerChildren: 0.03,
        staggerDirection: -1,
      },
    },
  };

  // Animation variants for nested items
  const nestedItemVariants = {
    hidden: { opacity: 0, x: -5 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.15 },
    },
    exit: {
      opacity: 0,
      x: -5,
      transition: { duration: 0.1 },
    },
  };

  return (
    <div
      className="libas-menu-container montserrat-font"
      style={{
        position: "sticky",
        top: "0",
        left: "0",
        bottom: "0",
        right: "0",
        zIndex: "10000",
        overflowY: "scroll",
      }}
    >
      {/* Logo and Close Button */}
      <div className="menu-header d-flex justify-content-between align-items-center py-4">
        <div className="logo ">
          <img src={libasmini} alt="libasmini" />
        </div>
        <button
          className="close-button bg-transparent border-0 "
          onClick={() => setShowSearchh(false)}
          style={{
            position: "relative",
            right: "12px",
          }}
        >
          <img src={menuclose} alt="menuclose" />
        </button>
      </div>

      {/* search bar new */}
      <div
        className="input-group ml-3 "
        style={{
          width: "95%",
          margin: "0 auto",
          backgroundColor: "#F5F5F5",
          borderRadius: "3px",
          flexWrap: "nowrap",
          direction: i18n.language === "ar" ? "rtl" : "ltr",
        }}
      >
        <span
          className="input-group-text bg-transparent"
          style={{
            border: "none",
            padding: "0.5rem 0.75rem",
          }}
        >
          <img
            src={Search}
            alt="Search"
            style={{ width: "16px", height: "16px" }}
          />
        </span>

        <input
          type="text"
          className={`form-control px-0 ${
            i18n.language == "en"
              ? "search-nav-new-menu"
              : "search-navAr-new-menu"
          }`}
          style={{
            padding: "0.5rem 0.75rem",
            minWidth: 0,
            flex: 1,
            direction: i18n.language === "ar" ? "rtl" : "ltr",
          }}
          placeholder={t("placeholderSeacrh")}
          onClick={() => {
            setSeacrhDrop(true);
          }}
          onChange={(e) => {
            setSearchQ(e.target.value);
            dispatch(getLastDoc(null));
          }}
          onKeyDown={handleSearch}
          value={searchQ}
          aria-label="Search"
        />
      </div>

      {/* Navigation Categories */}
      <div
        className="category-menu"
        style={{
          color: "#404040",
          fontSize: "14px",
        }}
      >
        {/* New Arrival */}
        <div className="category-item mt-3">
          <motion.div
            className="d-flex justify-content-between align-items-center p-2 px-3"
            onClick={() => toggleCategory("newArrival")}
            style={{
              borderBottom:
                expandedCategory === "newArrival"
                  ? "none"
                  : "1px solid #dee2e6",
              borderBottomColor:
                expandedCategory === "newArrival" ? "#333" : "#eee",
              borderBottomWidth:
                expandedCategory === "newArrival" ? "2px" : "1px",
              cursor: "pointer",
            }}
          >
            <Link
              to={`/products?topic=newdrops`}
              className="titlemega"
              style={{
                textDecoration: "none",
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (activeFilter === "new arrivals") {
                  setHide(true);
                  return;
                } else {
                  setActiveFilter("new arrivals");
                  setHide(true);
                  selectedPageNull();
                }
              }}
            >
              <motion.span
                className=""
                style={{
                  color: "#404040",
                  fontWeight: expandedCategory === "newArrival" ? "500" : "400",
                  textDecoration:
                    expandedCategory === "newArrival" ? "underline" : "none",
                }}
                whileHover={{ scale: 1.02 }}
              >
                {t("New Arrivals")}
              </motion.span>
            </Link>

            {/* Animated arrow icon */}
            <motion.div
              animate={{ rotate: expandedCategory === "newArrival" ? 180 : 0 }}
              transition={{ duration: 0.3 }}
            >
              <img
                src={expandedCategory === "menss" ? menuup : menudown}
                alt="expand"
              />
            </motion.div>
          </motion.div>
          <AnimatePresence>
            {expandedCategory === "newArrival" && (
              <motion.div
                className="subcategory-container p-1 px-3"
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={categoryContainerVariants}
              >
                <div className="row">
                  <div className="col-12 p-0">
                    {/* submenus of newArrival */}
                    <ul className="list-unstyled">
                      {/* new arrivals with nested options */}
                      <motion.li
                        className="p-2"
                        style={{
                          borderBottom: "1px solid #dee2e6",
                        }}
                        variants={subcategoryItemVariants}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <Link
                            to={`/products?topic=newdrops`}
                            className="subtitlemega "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            <motion.button
                              className="btn btn-link text-decoration-none p-0 text-dark"
                              style={{
                                marginLeft: "15px",
                              }}
                              onClick={() =>
                                navigateToCategory("newArrival", "clothes")
                              }
                            >
                              {/* {t("New Arrivals")} */}
                              New In
                            </motion.button>
                          </Link>
                          {/* Animated arrow for subcategory */}
                          <motion.span
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleSubcategory("clothes");
                            }}
                            whileHover={{ scale: 1.2 }}
                            whileTap={{ scale: 0.95 }}
                            animate={{
                              rotate: expandedSubcategories.clothes ? 180 : 0,
                            }}
                            transition={{ duration: 0.2 }}
                          >
                            <img
                              src={
                                expandedSubcategories.clothes
                                  ? menudown
                                  : menudown
                              }
                              alt="menudown"
                            />
                          </motion.span>
                        </div>

                        {/* Nested menu for new arrivals */}
                        <AnimatePresence>
                          {expandedSubcategories.clothes && (
                            <motion.ul
                              className="list-unstyled ms-4 mt-2"
                              initial="hidden"
                              animate="visible"
                              exit="exit"
                              variants={nestedMenuVariants}
                            >
                              <Link
                                // to="/products?topic=newdrops&id=yJDeEt0uKPxfxtqOM42V&"
                                to="/products?topic=proSeller"
                                className="subtitlemega "
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "new arrivals") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("new arrivals");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "newArrival",
                                        "clothes",
                                        "dresses"
                                      )
                                    }
                                  >
                                    {/* {t("Clothes")} */}
                                    We Trust
                                  </motion.button>
                                </motion.li>
                              </Link>
                              <Link
                                to="/products?topic=newdrops&id=AqFLulu9y2m4mqEIkch1"
                                className="subtitlemega  "
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "new arrivals") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("new arrivals");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "newArrival",
                                        "clothes",
                                        "tops"
                                      )
                                    }
                                  >
                                    {t("Bags")}
                                  </motion.button>
                                </motion.li>
                              </Link>
                              <Link
                                // to="/products?topic=newdrops&id=WJmwaMSWxtl1dK1sPZ1x"
                                to="/products?topic=Vintage"
                                className="subtitlemega  "
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "new arrivals") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("new arrivals");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "newArrival",
                                        "clothes",
                                        "pants"
                                      )
                                    }
                                  >
                                    {/* {t("Shoes")} */}
                                    Vintage
                                  </motion.button>
                                </motion.li>
                              </Link>
                              <Link
                                to="/products?topic=newdrops&id=07kdA6cD3NDKxX8pQ7w1"
                                className="  "
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "new arrivals") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("new arrivals");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "newArrival",
                                        "clothes",
                                        "pants"
                                      )
                                    }
                                  >
                                    {t("Jewelry")}
                                  </motion.button>
                                </motion.li>
                              </Link>
                              <Link
                                to="/products?topic=newdrops&subcategory=kYTvn5wAxopx5jpqotC0&id=LVw0hUP9kEcd1Qr9CoEk"
                                className="  "
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "new arrivals") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("new arrivals");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "newArrival",
                                        "clothes",
                                        "pants"
                                      )
                                    }
                                  >
                                    {t("Watches")}
                                  </motion.button>
                                </motion.li>
                              </Link>
                            </motion.ul>
                          )}
                        </AnimatePresence>
                      </motion.li>

                      {/* womens with nested options */}
                      <motion.li
                        className="p-2"
                        style={{
                          borderBottom: "1px solid #dee2e6",
                        }}
                        variants={subcategoryItemVariants}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <Link
                            to={`/products?topic=newdrops&gender=WFA967se7qX0jYtySgTj`}
                            className=""
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            <motion.button
                              className="btn btn-link text-decoration-none p-0 text-dark"
                              style={{ marginLeft: "15px" }}
                              whileHover={{ x: 3 }}
                              onClick={() =>
                                navigateToCategory("newArrival", "womens")
                              }
                            >
                              {/* {t("Women")} */}
                              Women's
                            </motion.button>
                          </Link>
                          <motion.span
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleSubcategory("newarrivalwomens");
                            }}
                            whileHover={{ scale: 1.2 }}
                            whileTap={{ scale: 0.95 }}
                            animate={{
                              rotate: expandedSubcategories.newarrivalwomens
                                ? 180
                                : 0,
                            }}
                            transition={{ duration: 0.2 }}
                          >
                            <img
                              src={
                                expandedSubcategories.newarrivalwomens
                                  ? menudown
                                  : menudown
                              }
                              alt="menudown"
                            />
                          </motion.span>
                        </div>

                        {/* Nested menu for womens */}
                        <AnimatePresence>
                          {expandedSubcategories?.newarrivalwomens && (
                            <motion.ul
                              className="list-unstyled ms-4 mt-2"
                              initial="hidden"
                              animate="visible"
                              exit="exit"
                              variants={nestedMenuVariants}
                            >
                              <Link
                                to="/products?topic=newdrops&id=AqFLulu9y2m4mqEIkch1&gender=WFA967se7qX0jYtySgTj"
                                className="  "
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "new arrivals") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("new arrivals");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "newArrival",
                                        "bags",
                                        "handbags"
                                      )
                                    }
                                  >
                                    {t("Bags")}
                                  </motion.button>
                                </motion.li>
                              </Link>
                              <Link
                                to="/products?topic=newdrops&id=yJDeEt0uKPxfxtqOM42V&gender=WFA967se7qX0jYtySgTj&"
                                className="  "
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "new arrivals") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("new arrivals");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "newArrival",
                                        "bags",
                                        "backpacks"
                                      )
                                    }
                                  >
                                    {t("Clothes")}
                                  </motion.button>
                                </motion.li>
                              </Link>
                              <Link
                                to="/products?topic=newdrops&id=WJmwaMSWxtl1dK1sPZ1x&gender=WFA967se7qX0jYtySgTj&"
                                className="  "
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "new arrivals") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("new arrivals");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "newArrival",
                                        "bags",
                                        "clutches"
                                      )
                                    }
                                  >
                                    {t("Shoes")}
                                  </motion.button>
                                </motion.li>
                              </Link>
                              <Link
                                to="/products?topic=newdrops&id=LVw0hUP9kEcd1Qr9CoEk&gender=WFA967se7qX0jYtySgTj&"
                                className="  "
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "new arrivals") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("new arrivals");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "newArrival",
                                        "bags",
                                        "clutches"
                                      )
                                    }
                                  >
                                    {t("Accessories")}
                                  </motion.button>
                                </motion.li>
                              </Link>
                              <Link
                                to="/products?topic=newdrops&subcategory=kYTvn5wAxopx5jpqotC0&id=LVw0hUP9kEcd1Qr9CoEk&gender=WFA967se7qX0jYtySgTj&"
                                className="  "
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "new arrivals") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("new arrivals");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "newArrival",
                                        "bags",
                                        "clutches"
                                      )
                                    }
                                  >
                                    {t("Watches")}
                                  </motion.button>
                                </motion.li>
                              </Link>
                              <Link
                                to="/products?topic=newdrops&id=07kdA6cD3NDKxX8pQ7w1&gender=WFA967se7qX0jYtySgTj&"
                                className="  "
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "new arrivals") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("new arrivals");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "newArrival",
                                        "bags",
                                        "clutches"
                                      )
                                    }
                                  >
                                    {t("Jewelry")}
                                  </motion.button>
                                </motion.li>
                              </Link>
                            </motion.ul>
                          )}
                        </AnimatePresence>
                      </motion.li>

                      {/* mens with nested options */}
                      <motion.li
                        className="p-2"
                        style={{
                          borderBottom: "1px solid #dee2e6",
                        }}
                        variants={subcategoryItemVariants}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <Link
                            to={`/products?topic=newdrops&gender=KG3s4pPk3arcBux5ERnD`}
                            className=""
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            <motion.button
                              className="btn btn-link text-decoration-none p-0 text-dark"
                              style={{ marginLeft: "15px" }}
                              whileHover={{ x: 3 }}
                              onClick={() =>
                                navigateToCategory("newArrival", "mens")
                              }
                            >
                              Men's
                            </motion.button>
                          </Link>
                          <motion.span
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleSubcategory("newarrivalmens");
                            }}
                            whileHover={{ scale: 1.2 }}
                            whileTap={{ scale: 0.95 }}
                            animate={{
                              rotate: expandedSubcategories.newarrivalmens
                                ? 180
                                : 0,
                            }}
                            transition={{ duration: 0.2 }}
                          >
                            <img
                              src={
                                expandedSubcategories.newarrivalmens
                                  ? menudown
                                  : menudown
                              }
                              alt="menudown"
                            />
                          </motion.span>
                        </div>

                        {/* Nested menu for mens */}
                        <AnimatePresence>
                          {expandedSubcategories.newarrivalmens && (
                            <motion.ul
                              className="list-unstyled ms-4 mt-2"
                              initial="hidden"
                              animate="visible"
                              exit="exit"
                              variants={nestedMenuVariants}
                            >
                              <Link
                                to="/products?topic=newdrops&id=AqFLulu9y2m4mqEIkch1&gender=KG3s4pPk3arcBux5ERnD"
                                className="  "
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "new arrivals") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("new arrivals");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "newArrival",
                                        "bags",
                                        "handbags"
                                      )
                                    }
                                  >
                                    {t("Bags")}
                                  </motion.button>
                                </motion.li>
                              </Link>
                              <Link
                                to="/products?topic=newdrops&id=yJDeEt0uKPxfxtqOM42V&gender=KG3s4pPk3arcBux5ERnD&"
                                className="  "
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "new arrivals") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("new arrivals");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "newArrival",
                                        "bags",
                                        "backpacks"
                                      )
                                    }
                                  >
                                    {t("Clothes")}
                                  </motion.button>
                                </motion.li>
                              </Link>
                              <Link
                                to="/products?topic=newdrops&id=WJmwaMSWxtl1dK1sPZ1x&gender=KG3s4pPk3arcBux5ERnD&"
                                className="  "
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "new arrivals") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("new arrivals");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "newArrival",
                                        "bags",
                                        "clutches"
                                      )
                                    }
                                  >
                                    {t("Shoes")}
                                  </motion.button>
                                </motion.li>
                              </Link>
                              <Link
                                to="/products?topic=newdrops&id=LVw0hUP9kEcd1Qr9CoEk&gender=KG3s4pPk3arcBux5ERnD&"
                                className="  "
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "new arrivals") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("new arrivals");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "newArrival",
                                        "bags",
                                        "clutches"
                                      )
                                    }
                                  >
                                    {t("Accessories")}
                                  </motion.button>
                                </motion.li>
                              </Link>
                              <Link
                                to="/products?topic=newdrops&subcategory=kYTvn5wAxopx5jpqotC0&id=LVw0hUP9kEcd1Qr9CoEk&gender=KG3s4pPk3arcBux5ERnD&"
                                className="  "
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "new arrivals") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("new arrivals");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "newArrival",
                                        "bags",
                                        "clutches"
                                      )
                                    }
                                  >
                                    {t("Watches")}
                                  </motion.button>
                                </motion.li>
                              </Link>
                              <Link
                                to="/products?topic=newdrops&id=07kdA6cD3NDKxX8pQ7w1&gender=KG3s4pPk3arcBux5ERnD&"
                                className="  "
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "new arrivals") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("new arrivals");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "newArrival",
                                        "bags",
                                        "clutches"
                                      )
                                    }
                                  >
                                    {t("Jewelry")}
                                  </motion.button>
                                </motion.li>
                              </Link>
                            </motion.ul>
                          )}
                        </AnimatePresence>
                      </motion.li>
                    </ul>
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
        {/* Designers */}
        <LibasMenuDesigners
          toggleCategory={toggleCategory}
          expandedCategory={expandedCategory}
          activeFilter={activeFilter}
          setHide={setHide}
          setActiveFilter={setActiveFilter}
          selectedPageNull={selectedPageNull}
          categoryContainerVariants={categoryContainerVariants}
          subcategoryItemVariants={subcategoryItemVariants}
          navigateToCategory={navigateToCategory}
          toggleSubcategory={toggleSubcategory}
          expandedSubcategories={expandedSubcategories}
          nestedMenuVariants={nestedMenuVariants}
          nestedItemVariants={nestedItemVariants}
        />
        {/* Womens */}
        <LibasMenuWomens
          toggleCategory={toggleCategory}
          expandedCategory={expandedCategory}
          activeFilter={activeFilter}
          setHide={setHide}
          setActiveFilter={setActiveFilter}
          selectedPageNull={selectedPageNull}
          categoryContainerVariants={categoryContainerVariants}
          subcategoryItemVariants={subcategoryItemVariants}
          navigateToCategory={navigateToCategory}
          toggleSubcategory={toggleSubcategory}
          expandedSubcategories={expandedSubcategories}
          nestedMenuVariants={nestedMenuVariants}
          nestedItemVariants={nestedItemVariants}
        />
        {/* mens */}
        <LibasMenuMens
          toggleCategory={toggleCategory}
          expandedCategory={expandedCategory}
          activeFilter={activeFilter}
          setHide={setHide}
          setActiveFilter={setActiveFilter}
          selectedPageNull={selectedPageNull}
          categoryContainerVariants={categoryContainerVariants}
          subcategoryItemVariants={subcategoryItemVariants}
          navigateToCategory={navigateToCategory}
          toggleSubcategory={toggleSubcategory}
          expandedSubcategories={expandedSubcategories}
          nestedMenuVariants={nestedMenuVariants}
          nestedItemVariants={nestedItemVariants}
        />
        {/* vintage */}
        <LibasMenuVintage
          toggleCategory={toggleCategory}
          expandedCategory={expandedCategory}
          activeFilter={activeFilter}
          setHide={setHide}
          setActiveFilter={setActiveFilter}
          selectedPageNull={selectedPageNull}
          categoryContainerVariants={categoryContainerVariants}
          subcategoryItemVariants={subcategoryItemVariants}
          navigateToCategory={navigateToCategory}
          toggleSubcategory={toggleSubcategory}
          expandedSubcategories={expandedSubcategories}
          nestedMenuVariants={nestedMenuVariants}
          nestedItemVariants={nestedItemVariants}
        />
        {/* bags */}
        <LibasMenuBags
          toggleCategory={toggleCategory}
          expandedCategory={expandedCategory}
          activeFilter={activeFilter}
          setHide={setHide}
          setActiveFilter={setActiveFilter}
          selectedPageNull={selectedPageNull}
          categoryContainerVariants={categoryContainerVariants}
          subcategoryItemVariants={subcategoryItemVariants}
          navigateToCategory={navigateToCategory}
          toggleSubcategory={toggleSubcategory}
          expandedSubcategories={expandedSubcategories}
          nestedMenuVariants={nestedMenuVariants}
          nestedItemVariants={nestedItemVariants}
        />
        {/* Shoes */}
        <LibasMenuShoes
          toggleCategory={toggleCategory}
          expandedCategory={expandedCategory}
          activeFilter={activeFilter}
          setHide={setHide}
          setActiveFilter={setActiveFilter}
          selectedPageNull={selectedPageNull}
          categoryContainerVariants={categoryContainerVariants}
          subcategoryItemVariants={subcategoryItemVariants}
          navigateToCategory={navigateToCategory}
          toggleSubcategory={toggleSubcategory}
          expandedSubcategories={expandedSubcategories}
          nestedMenuVariants={nestedMenuVariants}
          nestedItemVariants={nestedItemVariants}
        />
        {/* watch and jew */}
        <LibasMenuWatchandjews
          toggleCategory={toggleCategory}
          expandedCategory={expandedCategory}
          activeFilter={activeFilter}
          setHide={setHide}
          setActiveFilter={setActiveFilter}
          selectedPageNull={selectedPageNull}
          categoryContainerVariants={categoryContainerVariants}
          subcategoryItemVariants={subcategoryItemVariants}
          navigateToCategory={navigateToCategory}
          toggleSubcategory={toggleSubcategory}
          expandedSubcategories={expandedSubcategories}
          nestedMenuVariants={nestedMenuVariants}
          nestedItemVariants={nestedItemVariants}
        />
        {/* Childrens LibasMenuChildren */}
        <LibasMenuChildren
          toggleCategory={toggleCategory}
          expandedCategory={expandedCategory}
          activeFilter={activeFilter}
          setHide={setHide}
          setActiveFilter={setActiveFilter}
          selectedPageNull={selectedPageNull}
          categoryContainerVariants={categoryContainerVariants}
          subcategoryItemVariants={subcategoryItemVariants}
          navigateToCategory={navigateToCategory}
          toggleSubcategory={toggleSubcategory}
          expandedSubcategories={expandedSubcategories}
          nestedMenuVariants={nestedMenuVariants}
          nestedItemVariants={nestedItemVariants}
        />
        {/* Sale LibasMenuSale*/}
        <LibasMenuSale
          toggleCategory={toggleCategory}
          expandedCategory={expandedCategory}
          activeFilter={activeFilter}
          setHide={setHide}
          setActiveFilter={setActiveFilter}
          selectedPageNull={selectedPageNull}
          categoryContainerVariants={categoryContainerVariants}
          subcategoryItemVariants={subcategoryItemVariants}
          navigateToCategory={navigateToCategory}
          toggleSubcategory={toggleSubcategory}
          expandedSubcategories={expandedSubcategories}
          nestedMenuVariants={nestedMenuVariants}
          nestedItemVariants={nestedItemVariants}
        />
      </div>
    </div>
  );
};

export default LibasMenu;
